document.addEventListener('DOMContentLoaded', function() {
    // Cache DOM elements at the start
    const elements = {
        demoVideo: document.getElementById('demo-video'),
        workflowVideo: document.getElementById('workflow-creation-video'),
        testsVideo: document.getElementById('run-custom-tests'),
        reportVideo: document.getElementById('report-ai'),
        indianCTA: document.getElementById('indian-cta'),
        globalCTA: document.getElementById('global-cta'),
        heroText: document.getElementById('hero-text'),
        fadeElems: document.querySelectorAll('.fade-in')
    };

    // Initialize videos with a single configuration object
    const videoConfig = {
        'workflow-creation-video': 1.5,
        'demo-video': 1,
        'run-custom-tests': 1.5,
        'report-ai': 3
    };

    // Configure all videos at once
    Object.entries(videoConfig).forEach(([id, rate]) => {
        const video = document.getElementById(id);
        if (video) {
            video.addEventListener('loadedmetadata', function() {
                console.log('loaded video')
                this.currentTime = 2;
              }, false);
        }
    });

    // Define your typing sequences
    const typingSequences = [
      "runs standups",
      "tracks GitHub",
      "queries Hubspot",
      "connects Notion",
      "answers questions",
    ];

    // Initialize Typed.js
    new Typed('#typing-text', {
      strings: typingSequences,
      typeSpeed: 50,
      backSpeed: 20,
      backDelay: 1500,
      loop: true,
      showCursor: false,
    });

    // Optimized animation function for count-up
    const animateCount = (element, target) => {
        let startTime = null;
        const DURATION = 2000; // 2 seconds duration
        
        const update = (currentTime) => {
            if (!startTime) startTime = currentTime;
            const progress = (currentTime - startTime) / DURATION;
            
            if (progress >= 1) {
                element.textContent = target.toLocaleString();
                return;
            }
            
            const current = Math.min(Math.round(target * progress), target);
            element.textContent = current.toLocaleString();
            requestAnimationFrame(update);
        };
        
        requestAnimationFrame(update);
    };

    // Optimized Intersection Observer configuration
    const observerConfig = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
    };

    // Single reusable observer handler
    const handleIntersection = (entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const target = entry.target;
                
                if (target === elements.demoVideo) {
                    target.play();
                } else if (target.classList.contains('count-up')) {
                    // Start count-up animation when element is in view
                    const targetValue = parseInt(target.dataset.target, 10);
                    animateCount(target, targetValue);
                    observer.unobserve(target);
                } else {
                    target.style.opacity = 1;
                    target.style.transform = 'translateY(0px)';
                    observer.unobserve(target);
                }
            } else if (entry.target === elements.demoVideo) {
                entry.target.pause();
            }
        });
    };

    // Create single observer instance
    const intersectionObserver = new IntersectionObserver(handleIntersection, observerConfig);

    // Handle CTA visibility
    elements.heroText.style.opacity = 1;
    elements.heroText.style.transform = 'translateY(0px)';
    
    const ctaToShow = isIndianUser ? elements.indianCTA : elements.globalCTA;
    const ctaToHide = isIndianUser ? elements.globalCTA : elements.indianCTA;
    ctaToShow.classList.remove('hidden');
    ctaToHide.classList.add('hidden');

    // Observe elements
    elements.fadeElems.forEach(elem => intersectionObserver.observe(elem));
    intersectionObserver.observe(elements.demoVideo);
    
    // Observe count-up elements
    document.querySelectorAll('.count-up').forEach(elem => intersectionObserver.observe(elem));

    // Trigger hero animation after a small delay
    setTimeout(() => {
        elements.heroText.classList.remove('opacity-0', 'translate-y-12');
        elements.heroText.classList.add('opacity-100', 'translate-y-0');
    }, 1000);
});

// Optimized countUp function with requestAnimationFrame for better performance
function startCountUp() {
    const countUpElements = document.querySelectorAll('.count-up');
    const DURATION = 2000;
    const FPS = 60;
    const TOTAL_FRAMES = DURATION / (1000 / FPS);

    const animateCount = (element, target) => {
        let startTime = null;
        
        const update = (currentTime) => {
            if (!startTime) startTime = currentTime;
            const progress = (currentTime - startTime) / DURATION;
            
            if (progress >= 1) {
                element.textContent = target.toLocaleString();
                return;
            }
            
            const current = Math.min(Math.round(target * progress), target);
            element.textContent = current.toLocaleString();
            requestAnimationFrame(update);
        };
        
        requestAnimationFrame(update);
    };

    // Use a single IntersectionObserver for all count-up elements
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const target = parseInt(entry.target.dataset.target);
                animateCount(entry.target, target);
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0.5 });

    countUpElements.forEach(element => observer.observe(element));
}